import { DataSource, Label, Layout, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutDataFusionInvoicesFromBillingHistory extends Layout {
    labelAmountOutstanding: Label;
    labelInvoiceTotal: Label;
    searchpanelBillingHistory: SearchPanel;
    sourceDataFusionInvoicesFromHistory: DataSource;
    tableMissingBills: Table;
    textboxBillingUser: Textbox;
    textboxCustomer: Textbox;
    textboxPartnerId: Textbox;
    textboxRangeOfDates: Textbox;
}
